import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import React, { FunctionComponent, memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {closeModalIcon} from '../../../../assets/icons/icons';
import { Button } from '../../../../components/StyledComponents';
import './style.scss';
import {IAddPlatformProps} from "../../../../models/inner-models";
import Platform from "../../../../models/platforms-data";

const AddPlatform: FunctionComponent<IAddPlatformProps> = ({isOpen, closeNotification, add, list}: IAddPlatformProps) => {
  const { t: translate } = useTranslation();
  const [app, setApp] = useState<string>('');
  const allPlatform = ['github', 'trello', 'gitlab', 'jira']
  const onSubmit = () => {
    add(app);
    handleClose()
  };

  const handleClose = useCallback(() => {
    setApp('')
    closeNotification && closeNotification();
  }, []);

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="add-platform-title"
        aria-describedby="add-platform-description"
        classes={{
          paper: 'add-platform-modal',
        }}
      >
        <DialogTitle id="add-platform-title">
          Add Application
        </DialogTitle>
        <div className="close-btn" onClick={handleClose}>
          <img src={closeModalIcon} loading="lazy"/>
        </div>
        <DialogContent>
          <div id="add-platform-description">
            {allPlatform.map(item => {
              if (list.indexOf(item) === -1) {
                return (
                  <div
                    key={item}
                    className={item === app ? 'add-platform-item add-platform-item--active' : 'add-platform-item'}
                    onClick={()=>setApp(item)}
                  >
                    <img src={Platform[item]?.logo} className="add-platform-logo" loading="lazy"/>
                  </div>
                )
              }
            })}
            {Object.keys(Platform).map(item => {
              if (allPlatform.indexOf(item) === -1) {
                return (
                  <div key={item} className='add-platform-item add-platform-item--inactive' title='Coming soon'>
                    <img src={Platform[item]?.logo} className="add-platform-logo" loading="lazy"/>
                  </div>
                )
              }
            })}
          </div>
          <div className="action-buttons">
            <Button
              onClick={handleClose}
              variant="outlined"
              color="primary"
            >
              {translate('notifications.choices.cancel')}
            </Button>
            <Button
              onClick={onSubmit}
              variant="contained"
              color="primary"
              disabled={!app}
            >
              Add
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default memo(AddPlatform);
